import { AlertSan } from "../../types/AlertSan/AlertSan";
import { PaginationValues } from "../../types/General/PaginationValues";
import api from "../../utils/api";
import { ALERT_SAN_URL } from "../../utils/endpoints";

export async function getAlertSan(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(
      id ? `${ALERT_SAN_URL}/${id}` : `${ALERT_SAN_URL}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );
    const data: AlertSan[] = id
      ? response.data.name
      : response.data.result.map((option: AlertSan) => ({
          id: option.id,
          name: option.name,
          rationalDescription: option.rationalDescription,
          impactDescription: option.impactDescription,
          frequency: option.frequency,
          indicators: option.indicators,
        }));

    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
